import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AuthService } from '../services/auth.service';

export const unknownUserInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const enBandeja = router.url.startsWith('/bandeja-recepcion');

  if (enBandeja && authService.getLoginName() === 'USUARIO_DESCONOCIDO') {
    Swal.fire({
      icon: 'warning',
      title: 'Usuario Desconocido',
      html: `Se intentó realizar una operación sin sesión válida.<br><br>
             <b>Hora:</b> ${new Date().toLocaleString('es-AR')}<br><br>
             Por favor, comuníquese con el área de Sistemas.`,
      confirmButtonText: 'Entendido',
      confirmButtonColor: '#d33',
    });
    return throwError(() => new Error('Operación bloqueada: usuario desconocido'));
  }

  return next(req);
};
